import React from 'react';
import { Grid, Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RuleOptions, RuleSelections, RuleSelectionHandlers } from '../common/types';

interface GeneralInfoTabProps {
    options: RuleOptions;
    selections: RuleSelections;
    handlers: RuleSelectionHandlers;
    mode: string;
}

export const GeneralInfoTab: React.FC<GeneralInfoTabProps> = ({ options, selections, handlers, mode }) => {
    const { t } = useTranslation();

    return (
        <Grid container spacing={2} sx={{ mt: 1.5 }}>
            <Grid size={{ xs: 12 }}>
                <Autocomplete
                    fullWidth
                    options={options.fixedRules}
                    value={selections.fixedRule}
                    isOptionEqualToValue={(option, value) => option?.fixed_rule_id === value?.fixed_rule_id}
                    getOptionLabel={(option) => option?.name || ''}
                    onChange={(event, newValue) => handlers.setFixedRule(newValue)}
                    renderInput={(params) => <TextField {...params} label={t('settings.pay_rules.dialog.fields.fixed_rule')} />}
                    disabled={mode === 'info'}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Autocomplete
                    fullWidth
                    options={options.interpretationRules}
                    value={selections.interpretationRule}
                    isOptionEqualToValue={(option, value) => option?.interpretation_rule_id === value?.interpretation_rule_id}
                    getOptionLabel={(option) => option?.name || ''}
                    onChange={(event, newValue) => handlers.setInterpretationRule(newValue)}
                    renderInput={(params) => <TextField {...params} label={t('settings.pay_rules.dialog.fields.interpretation_rule')} />}
                    disabled={mode === 'info'}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Autocomplete
                    fullWidth
                    options={options.workRules}
                    value={selections.workRule}
                    isOptionEqualToValue={(option, value) => option?.work_rule_id === value?.work_rule_id}
                    getOptionLabel={(option) => option?.name || ''}
                    onChange={(event, newValue) => handlers.setWorkRule(newValue)}
                    renderInput={(params) => <TextField {...params} label={t('settings.pay_rules.dialog.fields.work_rule_default')} />}
                    disabled={mode === 'info'}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Autocomplete
                    fullWidth
                    options={options.creditHolidayRules}
                    value={selections.creditHolidayRule}
                    isOptionEqualToValue={(option, value) => option?.holiday_rule_id === value?.holiday_rule_id}
                    getOptionLabel={(option) => option?.name || ''}
                    onChange={(event, newValue) => handlers.setCreditHolidayRule(newValue)}
                    renderInput={(params) => <TextField {...params} label={t('settings.pay_rules.dialog.fields.credit_holiday_default')} />}
                    disabled={mode === 'info'}
                />
            </Grid>
        </Grid>
    );
};
